<template>
  <JadeFloating
    v-bind="$attrs"
    :open="open"
    :closeOn="closeOn"
    :zIndex="zIndex"
    allowOutsideClick
    @toggle="() => $emit('toggle')"
  >
    <div
      class="jade-drawer"
      tabindex="-1"
      style="
        transform: translateX(0px);
        transition-property: transform;
        transition-duration: 250ms;
      "
      :class="{ slideIn: open, slideOut: !open }"
    >
      <div class="jade-drawer__container">
        <JadeNavigationBar
          navigateType="close"
          background="surface"
          :label="title"
          :trailingAction="trailingAction"
          @trailingActionClick="() => $emit('trailingActionClick')"
          @onNavigate="() => $emit('toggle')"
        >
          <template #trailingItem>
            <slot name="trailingItem" />
          </template>
        </JadeNavigationBar>
        <main :class="computedClassMain">
          <JadeSpinner
            v-if="loading"
            size="xlarge"
            color="medium"
          />
          <slot v-else />
        </main>
      </div>
    </div>
  </JadeFloating>
</template>

<script>
import JadeNavigationBar from '../JadeNavigationBar'
import JadeSpinner from '../JadeSpinner'
import JadeFloating from '../JadeFloating'

export default {
  name: 'JadeDrawer',

  components: {
    JadeNavigationBar,
    JadeSpinner,
    JadeFloating
  },

  props: {
    title: {
      type: String,
      required: true
    },
    loading: Boolean,
    open: Boolean,
    trailingAction: Object,
    closeOn: {
      type: Array,
      default: () => ['esc']
    },
    zIndex: {
      type: Number,
      default: 1200
    }
  },

  computed: {
    computedClassMain () {
      return {
        'jade-drawer__content': true,
        'is-loading': this.loading
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/drawer.css';

@keyframes slideIn {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOut {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}

.slideIn {
  animation: slideIn 0.5s forwards;
}

.slideOut {
  animation: slideOut 0.5s forwards;
}
</style>
